export default __webpack_public_path__ + "static/media/IMG_20200722_111901 - Pranav Shekhar.f51116c2.jpg";